import React from "react";
import styles from "./content-wrapper.module.scss";
import classNames from "classnames";

type Props = {
  children: React.ReactNode;
};

const ContentWrapper = ({ children }: Props) => {
  return <main className={styles.wrapperContainer}>{children}</main>;
};

export default ContentWrapper;
